var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"helper-page"},[_vm._l((_vm.stepOptions),function(item){return [_c('step-component',{key:'STEP_OPTION_ITEM_KEY_'+item.title,attrs:{"title":item.title,"sub-title":item.subTitle,"img":item.img}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }